<app-loading *ngIf="contentReady"></app-loading>

<section
  class="login-page register-page"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="atw-container login-container">
    <div class="login-shell">

      <div class="login-shell-header">
        <div class="login-title">
          <span class="login-section-badge">
            <b>{{ 'auth.register.badgeNumber' | transloco }}</b>
            {{ 'auth.register.badgeTitle' | transloco }}
          </span>

          <h1>
            {{ 'auth.register.heroTitleLine1' | transloco }}
            <strong>{{ 'auth.register.heroTitleStrong' | transloco }}</strong>
          </h1>

          <p>
            {{ 'auth.register.heroText' | transloco }}
          </p>
        </div>

        <div class="login-live-label">
          <img class="img-m" src="assets/as/27.webp" alt="secure" />
          {{ 'auth.register.secureLabel' | transloco }}
        </div>
      </div>

      <div class="login-grid register-grid">

        <!-- Brand Side -->
        <div class="login-brand-card register-brand-card">
          <div class="brand-mark">
            <strong>IN</strong>
          </div>

          <span class="brand-tag">
            {{ 'auth.register.brandTag' | transloco }}
          </span>

          <h2>
            {{ 'auth.register.brandTitle' | transloco }}
          </h2>

          <p>
            {{ 'auth.register.brandText' | transloco }}
          </p>

          <div class="login-features">
            <div>
              <img class="img-m" src="assets/as/27.webp" alt="check" />
              <span>{{ 'auth.register.feature1' | transloco }}</span>
            </div>

            <div>
              <img class="img-m" src="assets/as/27.webp" alt="check" />
              <span>{{ 'auth.register.feature2' | transloco }}</span>
            </div>

            <div>
              <img class="img-m" src="assets/as/27.webp" alt="check" />
              <span>{{ 'auth.register.feature3' | transloco }}</span>
            </div>
          </div>

          <div class="register-mini-card">
            <img class="img-xl" src="assets/as/9.webp" alt="company" />

            <div>
              <strong>{{ 'auth.register.companyMiniTitle' | transloco }}</strong>
              <small>{{ 'auth.register.companyMiniText' | transloco }}</small>
            </div>
          </div>

          <div class="brand-bottom-line">
            <span></span>
          </div>
        </div>

        <!-- Form Side -->
        <div class="login-form-card register-form-card">
          <div class="login-card-head">
            <span class="login-badge">
              {{ 'auth.register.cardBadge' | transloco }}
            </span>

            <h2>
              {{
                isUpdatePage
                  ? ('auth.register.editTitle' | transloco)
                  : ('auth.register.title' | transloco)
              }}
            </h2>

            <p>
              {{
                isUpdatePage
                  ? ('auth.register.editSubtitle' | transloco)
                  : ('auth.register.subtitle' | transloco)
              }}
            </p>
          </div>

          <form
            class="login-form register-form"
            [formGroup]="formInfo"
            (ngSubmit)="onSubmit()"
            novalidate
          >
            <div class="register-form-grid">
              <div class="login-field">
                <label>{{ 'auth.register.firstNameLabel' | transloco }}</label>

                <input
                  type="text"
                  formControlName="first_name"
                  [placeholder]="'auth.register.firstNamePlaceholder' | transloco"
                  autocomplete="given-name"
                  [class.invalid]="isInvalid('first_name')"
                />

                <small *ngIf="isInvalid('first_name')">
                  {{ 'auth.register.firstNameRequired' | transloco }}
                </small>
              </div>

              <div class="login-field">
                <label>{{ 'auth.register.lastNameLabel' | transloco }}</label>

                <input
                  type="text"
                  formControlName="last_name"
                  [placeholder]="'auth.register.lastNamePlaceholder' | transloco"
                  autocomplete="family-name"
                  [class.invalid]="isInvalid('last_name')"
                />

                <small *ngIf="isInvalid('last_name')">
                  {{ 'auth.register.lastNameRequired' | transloco }}
                </small>
              </div>
            </div>

            <div class="register-form-grid">
              <div class="login-field">
                <label>{{ 'auth.register.usernameLabel' | transloco }}</label>

                <input
                  type="text"
                  formControlName="username"
                  [placeholder]="'auth.register.usernamePlaceholder' | transloco"
                  autocomplete="username"
                  [class.invalid]="isInvalid('username')"
                />

                <small *ngIf="isInvalid('username')">
                  {{ 'auth.register.usernameRequired' | transloco }}
                </small>
              </div>

              <div class="login-field">
                <label>{{ 'auth.register.phoneLabel' | transloco }}</label>

                <input
                  type="text"
                  formControlName="phone"
                  [placeholder]="'auth.register.phonePlaceholder' | transloco"
                  autocomplete="tel"
                  [class.invalid]="isInvalid('phone')"
                />

                <small *ngIf="isInvalid('phone')">
                  {{ 'auth.register.phoneInvalid' | transloco }}
                </small>
              </div>
            </div>

            <div class="login-field">
              <label>{{ 'auth.register.passwordLabel' | transloco }}</label>

              <div class="password-field">
                <input
                  [type]="isPasswordVisible ? 'text' : 'password'"
                  formControlName="password"
                  [placeholder]="'auth.register.passwordPlaceholder' | transloco"
                  autocomplete="new-password"
                  [class.invalid]="isInvalid('password')"
                />

                <button
                  type="button"
                  class="toggle-password"
                  (click)="togglePasswordVisibility()"
                >
                  {{
                    isPasswordVisible
                      ? ('auth.register.hidePassword' | transloco)
                      : ('auth.register.showPassword' | transloco)
                  }}
                </button>
              </div>

              <small *ngIf="isInvalid('password')">
                {{ 'auth.register.passwordRequired' | transloco }}
              </small>
            </div>

            <div class="login-field">
              <label>{{ 'auth.register.confirmPasswordLabel' | transloco }}</label>

              <div class="password-field">
                <input
                  [type]="isPasswordVisible ? 'text' : 'password'"
                  formControlName="c_Password"
                  [placeholder]="'auth.register.confirmPasswordPlaceholder' | transloco"
                  autocomplete="new-password"
                  [class.invalid]="isConfirmPasswordInvalid()"
                />
              </div>

              <small *ngIf="isConfirmPasswordInvalid()">
                {{ 'auth.register.confirmPasswordInvalid' | transloco }}
              </small>
            </div>

            <!-- CV Upload -->
            <div class="login-field register-cv-field">
              <label>{{ 'auth.register.cvLabel' | transloco }}</label>

              <div
                class="pdf-uploader register-cv-uploader"
                [class.drag-over]="cvDragOver"
                [class.has-file]="selectedCvFile"
                (click)="!contentReady && cvInput.click()"
                (dragover)="onCvDragOver($event)"
                (dragleave)="onCvDragLeave($event)"
                (drop)="onCvDrop($event)"
              >
                <input
                  #cvInput
                  type="file"
                  accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,.doc,.docx"
                  hidden
                  [disabled]="contentReady"
                  (change)="onCvFileChange($event)"
                />

                <ng-container *ngIf="!selectedCvFile">
                  <div class="upload-icon">
                    <img
                      class="img-l"
                      src="assets/as/30.webp"
                      [alt]="'auth.register.cvUploadIconAlt' | transloco"
                    />
                  </div>

                  <h3>{{ 'auth.register.cvDropTitle' | transloco }}</h3>
                  <p>{{ 'auth.register.cvDropText' | transloco }}</p>

                  <button type="button" class="browse-btn">
                    {{ 'auth.register.cvChooseButton' | transloco }}
                    <span>↑</span>
                  </button>
                </ng-container>

                <ng-container *ngIf="selectedCvFile">
                  <div class="file-preview">
                    <div class="file-icon">
                      {{ getFileTypeLabel(selectedCvFile) }}
                    </div>

                    <div class="file-info">
                      <strong>{{ selectedCvFile.name }}</strong>
                      <span>{{ formatFileSize(selectedCvFile.size) }}</span>
                    </div>

                    <button
                      type="button"
                      class="remove-file"
                      [disabled]="contentReady"
                      [attr.aria-label]="'auth.register.cvRemoveFile' | transloco"
                      (click)="removeCvFile($event)"
                    >
                      ×
                    </button>
                  </div>
                </ng-container>
              </div>

              <small class="cv-helper-text">
                {{ 'auth.register.cvOptionalNote' | transloco }}
              </small>

              <div class="error-message" *ngIf="cvErrorKey">
                {{ cvErrorKey | transloco }}
              </div>
            </div>

            <div class="login-note">
              <i>i</i>
              <span>{{ 'auth.register.note' | transloco }}</span>
            </div>

            <button
              type="submit"
              class="login-submit"
              [disabled]="contentReady || formInfo.invalid"
            >
              {{
                contentReady
                  ? ('auth.register.loading' | transloco)
                  : isUpdatePage
                  ? ('auth.register.editSubmit' | transloco)
                  : ('auth.register.submit' | transloco)
              }}
            </button>

            <div class="register-or">
              <span>{{ 'auth.register.or' | transloco }}</span>
            </div>

            <button
              type="button"
              class="company-account-btn"
              (click)="goCompanyAccount()"
            >
              <img class="img-m" src="assets/as/9.webp" alt="company" />
              <span>{{ 'auth.register.companyAccountButton' | transloco }}</span>
            </button>

            <div class="register-link-container">
              <span>{{ 'auth.register.haveAccount' | transloco }}</span>

              <a routerLink="/Login">
                {{ 'auth.register.loginNow' | transloco }}
              </a>
            </div>
          </form>
        </div>

      </div>

    </div>
  </div>
</section>